module.exports = __webpack_public_path__ + "img/build.47378e97.svg";